import React from "react";

const NotFound = () => {
  return (
    <div>
      <h1>Sorry, The page Not Found. 404</h1>
    </div>
  );
};

export default NotFound;
